import { CSSProperties } from 'react'

import classNames from 'classnames'

interface TableHeadersProps {
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
}

export const TableHeaders: React.FC<TableHeadersProps> = ({
  className,
  style,
  children,
}) => {
  return (
    <thead
      className={classNames('data-table-headers', className)}
      style={{ ...style }}
    >
      {children}
    </thead>
  )
}
